import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[ngDecimalLimit]',
})
export class DecimalLimitDirective {
  @Input() decimalPlaces :number = 2;

  constructor(private elementRef :ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeydown(event :KeyboardEvent) {
    const inputValue = this.elementRef.nativeElement.value;
    const decimalIndex = inputValue.indexOf('.');
    const allowedKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      '.',
      'Decimal',
    ];
    const invalidKeys = ['e', 'E'];

    // Allow backspace, delete, left arrow, right arrow, and decimal point
    if (allowedKeys.includes(event.key)) {
      return;
    }

    if (
      (decimalIndex !== -1 &&
        inputValue.length - decimalIndex > this.decimalPlaces) ||
      invalidKeys.includes(event.key)
    ) {
      event.preventDefault();
    }
  }
}
